import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartPulse } from "lucide-react";
import { useEmpresasLanguage } from "../context/EmpresasLanguageContext";
import { financialIntelligenceHealthcare } from "../data/financialIntelligenceHealthcare";

function EmpresasSalud() {
  const { lang } = useEmpresasLanguage();
  const t = (financialIntelligenceHealthcare[lang] || financialIntelligenceHealthcare.es).hub;

  return (
    <div className="overflow-x-hidden bg-white">
      <section className="relative bg-[#0F172A] text-white">
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage:
              "radial-gradient(circle at 15% 20%, rgba(16,185,129,0.25), transparent 40%), radial-gradient(circle at 85% 10%, rgba(56,189,248,0.15), transparent 35%)",
          }}
        />
        <div className="relative max-w-6xl mx-auto px-6 sm:px-10 lg:px-16 py-16 lg:py-24">
          <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-emerald-400">
            {t.eyebrow}
          </p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-semibold tracking-tight">{t.title}</h1>
          <p className="mt-5 text-lg text-slate-300 max-w-2xl leading-relaxed">{t.subtitle}</p>
        </div>
      </section>

      <section className="py-14 px-6 sm:px-10 lg:px-16">
        <div className="max-w-6xl mx-auto">
          <Link
            to="/empresas/salud/financial-intelligence"
            className="group block rounded-[2rem] border border-slate-200 bg-slate-50 p-8 sm:p-10 hover:border-emerald-300 hover:bg-white transition shadow-[0_20px_60px_-40px_rgba(15,23,42,0.35)]"
          >
            <div className="flex items-start gap-4">
              <div className="h-12 w-12 rounded-2xl bg-emerald-50 border border-emerald-100 flex items-center justify-center shrink-0">
                <HeartPulse className="w-6 h-6 text-emerald-600" />
              </div>
              <div className="flex-1">
                <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-emerald-600">
                  Monthly service
                </p>
                <h2 className="mt-2 text-2xl sm:text-3xl font-semibold text-[#0F172A] tracking-tight">
                  {t.serviceTitle}
                </h2>
                <p className="mt-3 text-slate-600 text-lg leading-relaxed max-w-3xl">{t.serviceBody}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0F172A]">
                  {t.serviceCta}
                  <ArrowRight className="w-4 h-4 transition group-hover:translate-x-1" />
                </span>
              </div>
            </div>
          </Link>

          <div className="mt-10">
            <Link to="/empresas" className="text-sm font-medium text-slate-500 hover:text-[#0F172A] transition">
              ← {t.back}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default EmpresasSalud;
